import React from 'react';

export const FarmStampNew = (_props: { multi: boolean }) => {
  return null;
};

export const FarmStampNewDCL = (_props: { multi: boolean }) => {
  return null;
};

export function FarmDot({
  inFarm,
  className,
}: {
  inFarm: boolean;
  className?: string;
}) {
  return (
    <div
      className={`rounded-full  ${
        inFarm ? 'bg-gradientFrom' : ''
      } w-2 h-2 border border-gradientFrom ${className}`}
    />
  );
}
